import type { IFurniture } from '@/editor/data/model/furniture';
import { IAssemblyData } from './assembly';
import { getUniqueId } from '@/editor/utils';
import { Vector3 } from 'three';
import { BoundingBox3 } from '@/editor/math/BoundingBox3';
import { getModelBoundingBox } from '../utils';

export function getFurnituresBoundingBox(datas: IFurniture[]) {
  const assemblyBoundingBox = new BoundingBox3();
  for (const data of datas) {
    const box = getModelBoundingBox(data);
    const points = box.points;
    assemblyBoundingBox.includePoints(points);
  }

  return assemblyBoundingBox;
}

export function createAssemblyData(datas: IFurniture[]) {
  const assemblyBoundingBox = getFurnituresBoundingBox(datas);

  const min = assemblyBoundingBox.min;
  const max = assemblyBoundingBox.max;
  const width = max.x - min.x;
  const thickness = max.y - min.y;
  const height = max.z - min.z;
  const offGround = min.z;
  const center = new Vector3((min.x + max.x) / 2, (min.y + max.y) / 2, (min.z + max.z) / 2);

  // const euler = new Euler(0, 0, 0); // XYZ顺序
  // const matrix = new Matrix4();
  // matrix.makeRotationFromEuler(euler);
  // matrix.setPosition(center);

  const assemblyData: IAssemblyData = {
    id: getUniqueId(),
    accessorieIds: datas.map((data) => data.id),
    center: { x: center.x, y: center.y },
    rotation: 0,
    offGround,
    width,
    thickness,
    height
  };

  return assemblyData;
}
